import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { unMaskCurrency } from '@utils/masks/unMaskCurrency'

export const editFgtsModalSchema = yupResolver(
  yup.object({
    value: yup
      .string()
      .required('O valor é obrigatório')
      .test('min-value', 'O valor deve ser maior que zero', (value) => {
        if (!value || value.trim() === '') return false
        const numericValue = unMaskCurrency(value)
        return !isNaN(numericValue) && numericValue > 0
      })
      .test('valid-currency', 'Digite um valor válido', (value) => {
        if (!value || value.trim() === '') return false
        const numericValue = unMaskCurrency(value)
        return !isNaN(numericValue)
      })
  })
)
